@if (value) {
  <div class="field-card-full">
    <span class="field-label">{{ question.label }}</span>
    <span class="field-value">{{ value }}</span>
  </div>
}
